import React, { useEffect, useRef, useState } from 'react';
import { Breadcrumb, Button, Col, Row, Select, ProgressProps, Progress } from 'antd';
import { connect } from 'react-redux';
import { getGeiYearsByOrganizationId, getCategoriesByOrganizationIdAndYear, getCategoriesByOrganizationUnifiedIdAndYear, getPortafolioGeiYearsByOrganizationId } from 'src/store/Results/thunks';
import { getAllOrganization } from 'src/store/organization/thunks';
import { getUserByToken, getUserByTokenAll } from 'src/store/user/thunks';
import { AppState } from 'src/store';
import { Organization } from '../../../store/organization/types';
import { CategoryResponse, CategoryResults, ResultsResponse } from 'src/store/Results/types';
import style from './Results.module.scss';
import styles from 'src/globals/Layout/Admin/AdminHeader.module.scss';
import { useHistory, useParams } from 'react-router-dom';
import Chart from 'chart.js/auto';
import { Bar, Doughnut } from 'react-chartjs-2';
import ResultsHeader from './ResultsHeader';
import { FileExcelOutlined } from '@ant-design/icons';
import { openNotification } from 'src/globals/Components/Notification/Notificaction';
import * as XLSX from 'xlsx';
import { DataTypePortafolio } from '../Tables/GeiPortafolio/TPortafolioOrganizations';
import { GeiInventory, GeiInventoryPortafolioResponse } from 'src/store/geiInventory/types';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';

interface ResultProps {
    getGeiYearsByOrganizationId?: any;
    getAllOrganization?: any;
    getUserByTokenAll?: any;
    getCategoriesByOrganizationUnifiedIdAndYear: any;
    oneResult: boolean;
    organization?: DataTypePortafolio | undefined;
    typeResult?: string;
    getPortafolioGeiYearsByOrganizationId?: any;
}





const ResultsUnified: React.FC<ResultProps> = (props: ResultProps) => {
    const [emissionSChart, setEmissionSChart] = useState([]);
    const [emissiontco2eChart, setEmissiontco2eChart] = useState([]);
    const [dataEmissionChart, setDataEmissionChart] = useState([]);
    const [nameChart, setNameChart] = useState([]);
    const [dataChart, setDataChart] = useState([]);
    const [isYearSelected, setIsYearSelected] = useState(false);
    const [organization, setOrganization] = useState([]);
    const history = useHistory();
    const [typeOrganization, setTypeOrganization] = useState("");
    const [typeYears, setTypeYears] = useState("");
    const [category, setCategory] = useState<CategoryResponse[]>([]);
    const [isNone, setIsNone] = useState("-none");
    const [results, setResults] = useState<ResultsResponse>();
    const [pieChartData, setPieChartData] = useState<any>(null);
    const { Option } = Select;
    interface RouteParams {
        type: string
    }
    const params = useParams<RouteParams>();
    const [year, setDataYears] = useState<GeiInventoryPortafolioResponse[]>([]);
    const chartRef = useRef<HTMLCanvasElement | null>(null); // Ref para el lienzo del gráfico
    const [isRol, setIsRol] = useState('');
    const init = async () => {
        setIsNone("-none");
        setCategory([]);
        setIsYearSelected(false);
        setDataChart([]);
        setTypeYears("")

        setNameChart([]);
        setEmissionSChart([])
        setEmissiontco2eChart([])
        setDataEmissionChart([])
        const responseUser = await props.getUserByTokenAll();
        setIsRol(responseUser.rol)
        if (props.oneResult) {
            let responseData; // Usamos let para poder reasignar
            setTypeOrganization(props.organization == undefined ? "" : props.organization?.id);
            switch (props.typeResult) {
                case "PORTAFOLIO":
                    // Aquí podrías asignar algo si corresponde
                    responseData = await props.getPortafolioGeiYearsByOrganizationId(
                        props.organization?.id
                    );
                    break;

                case "GEIINVENTARIO":
                    responseData = await props.getGeiYearsByOrganizationId(
                        props.organization?.id
                    );
                    break;

                default:
                    break;
            }
            if (responseData !== undefined) {
                setDataYears(responseData);
            } else {
                setDataYears([]);
                setIsNone("-none");
                setTypeYears("");
            }

        } else {
            const responseDataOrganization = await props.getAllOrganization();
            setOrganization(responseDataOrganization);
        }

    };

    useEffect(() => {
        init();
    }, [props.organization]);


    const handleChangeTypeOrganization = async (value: any) => {
        setTypeOrganization(value);
        setIsNone("-none");
        const responseData = await props.getGeiYearsByOrganizationId(value);
        if (responseData !== undefined) {
            setDataYears(responseData);
        } else {
            setDataYears([]);
            setIsNone("-none");
            setTypeYears("");
        }
    };
    const handleChangeTypeYears = async (value: any) => {
        const yearsResponse: GeiInventoryPortafolioResponse | undefined = year.find(values => values.id == value)
        setTypeYears(yearsResponse == undefined ? "" : yearsResponse?.year.toString());
        const responseData = await props.getCategoriesByOrganizationUnifiedIdAndYear(typeOrganization, yearsResponse?.year, props.typeResult);
        if (responseData != undefined) {
            setIsNone("")
            setCategory(responseData.categoryResponse);
            setResults(responseData);
        }

        setIsNone("");
        setCategory(responseData.categoryResponse);
        setResults(responseData);
        setIsYearSelected(true);
        const emissionS = responseData.categoryResponse.flatMap((category: any) =>
            category.categoryResults.map((result: any) => result.emissionSource)//Fuentes de Emision
        );

        const emissiontco2e = responseData.categoryResponse.flatMap((category: any) =>
            category.categoryResults.map((result: any) => result.tCO2e)//Fuentes de Emision
        );

        console.log(emissionS)
        const dataEmission = responseData.categoryResponse.flatMap((category: any) =>
            category.categoryResults.map((result: any) => parseFloat(result.tcO2e)));

        const dataEmissionInteger = dataEmission.map((value: number) => Math.floor(value));

        console.log(dataEmissionInteger)
        console.log(dataEmission)
        setEmissionSChart(emissionS);
        setDataEmissionChart(dataEmission);
        setEmissiontco2eChart(emissiontco2e);

        //obtenemos las categorias para la seccion 2
        const names = responseData.categoryResponse.map((item: any) => item.name);
        console.log(names)
        //obtenemos los valores de tCo2e para la seccion 2
        const data = responseData.categoryResponse.map((item: any) => item.totalinput);
        setNameChart(names);
        setDataChart(data);
    };
    const randomColor = () => '#' + Math.floor(Math.random() * 16777215).toString(16);
    const backgroundColors = dataEmissionChart.map(() => randomColor());
    const conicColors: ProgressProps['strokeColor'] = {
        '0%': '#87d068',
        '50%': '#ffe58f',
        '100%': '#ffccc7',
    };
    const twoColors: ProgressProps['strokeColor'] = {
        '0%': '#108ee9',
        '100%': '#87d068',
    };

    let dataBar1 = {
        labels: emissionSChart,
        datasets: [
            {
                label: 'Fuentes de Emisión X tCO2e:',
                data: dataEmissionChart,
                backgroundColor: backgroundColors
            },
        ],
    };
    const options = {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 100, // Establece el tamaño del paso en el eje Y
                    max: 10000, // Establece el valor máximo en el eje Y
                },
            },
        },
        plugins: {
            legend: {
                display: false
            },
        },
    };

    let dataPie2 = {
        labels: nameChart,
        datasets: [
            {
                data: dataChart
            },
        ],
    };
    let dataBar2 = {
        labels: nameChart,
        datasets: [
            {
                label: 'TOTAL CO2e(t)',
                data: dataChart
            },
        ],
    };

    const handleExportToExcel = () => {
        const exportData = category.map((categoryResponse: CategoryResponse) => {
            return categoryResponse.categoryResults.map((categoryResult: CategoryResults) => ({
                'Categoria': categoryResponse.name,
                'Establecimientos': categoryResult.establisment,
                'Fuente de emisión': categoryResult.emissionSource,
                'Flujo de Fuente': categoryResult.flow,
                't CO₂': categoryResult.tco2,
                't CH₄': categoryResult.tch4,
                't N₂O': categoryResult.tn26,
                't HFC': categoryResult.thfc,
                't CO₂e': categoryResult.tcO2e,
                'Aporte%': categoryResult.input,
            }));
        }).flat();
        const exportDataTotal = category.map((categoryResponse: CategoryResponse) => ({
            'Nombre': categoryResponse.name,
            'Tipo': categoryResponse.type,
            'Descripción': categoryResponse.description,
            'Total tco2': categoryResponse.totaltco2,
            'Total tch4': categoryResponse.totaltch4,
            'Total tn2o': categoryResponse.totaltn2o,
            'Total thfc': categoryResponse.totalthfc,
            'Total tco2e': categoryResponse.totaltco2e,
            'Total input': categoryResponse.totalinput,
        })).flat();

        const exportDataResults = {
            'Total tco2': results?.totalEmissiontco2,
            'Total tch4': results?.totalEmissiontch4,
            'Total tn2o': results?.totalEmissiontn2o,
            'Total thfc': results?.totalEmissionthfc,
            'Total tco2e': results?.totalEmissiontco2e,
            'Total input': results?.totalEmissioninput,
            'Total Biomasa': results?.totalEmissionBiomasa,
            'Total Hcfc': results?.totalHcfc,
        };
        const exportDataResultsArray = [exportDataResults];

        //results
        const ws = XLSX.utils.json_to_sheet(exportData);
        const ws2 = XLSX.utils.json_to_sheet(exportDataTotal);
        const ws3 = XLSX.utils.json_to_sheet(exportDataResultsArray);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Fuentes');
        XLSX.utils.book_append_sheet(wb, ws2, 'Total');
        XLSX.utils.book_append_sheet(wb, ws3, 'Resultados');

        const excelFileName = 'Resultados.xlsx';
        XLSX.writeFile(wb, excelFileName);

        openNotification("Exportación exitosa", `Los datos se han exportado a ${excelFileName}`);
    };

    useEffect(() => {
        if (chartRef.current && pieChartData) {
            const ctx = chartRef.current.getContext('2d');
            if (ctx) {
                new Chart(ctx, {
                    type: 'doughnut',
                    data: pieChartData,
                });
            }
        }
    }, [pieChartData]);

    return (
        <div>
            {/* <ResultsHeader unified={"-bold"} mensual={""} history={""} /> */}
            <AdminHeader>Resultados anuales</AdminHeader>
            <Row justify="center" style={{ width: "100%" }}>
                <Col lg={2}></Col>
                {!props.oneResult && <Col lg={8}>
                    Escoga la organización:
                    <Select
                        showSearch
                        style={{ width: "100%" }}
                        onChange={handleChangeTypeOrganization}
                        filterOption={(input: any, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={typeOrganization}
                        placeholder="Escoga la organización"
                    >
                        {organization.map((type: Organization) => (
                            <Option key={`type-option-${type}`} value={type.id}
                            >
                                {type.ruc + "-" + type.name}
                            </Option>
                        ))}
                    </Select>
                </Col>}
                <Col lg={4}>
                    Escoga el año
                    <Select

                        showSearch
                        style={{ width: "100%" }}
                        onChange={handleChangeTypeYears}
                        filterOption={(input: any, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={typeYears}
                        placeholder="Escoga el año"
                    >
                        {year.map((type: GeiInventoryPortafolioResponse) => (
                            <Option key={`type-option-${type.id}`} value={type.id}
                            >
                                {type.year}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col lg={2}></Col>
            </Row>
            <Row justify={"end"}>
                <Col>
                    <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        style={{ backgroundColor: '#1f71d9', borderColor: 'gray', marginLeft: '8px' }}
                        onClick={handleExportToExcel}
                    >
                        Exportar a Excel
                    </Button>

                </Col>

            </Row>

            <div className={style["title-reults"]} >
                1. DECLARACIÓN DE EMISIONES DE GEI POR ESTABLECIMIENTO
            </div>
            <Row justify="start" className={style["custom-row" + isNone]}>
                <Col lg={6}>
                    Fuente de emisión
                </Col>
                <Col lg={3}>
                    Flujo de Fuente
                </Col>
                <Col lg={2}>
                    t CO₂
                </Col>
                <Col lg={2}>
                    t CH₄
                </Col>
                <Col lg={2}>
                    t N₂O
                </Col>
                <Col lg={2}>
                    t HFC
                </Col>
                <Col lg={2}>
                    t CO₂e
                </Col>
                <Col lg={2}>
                    Aporte%
                </Col>

            </Row>
            {category.map((type: CategoryResponse) => (
                <div key={type.id} >
                    {type.categoryResults.map((type: CategoryResults) => (
                        <div key={type.establisment} >
                            <Row justify="start" className={style["custom-row-data" + isNone]}>
                                <Col lg={6}>
                                    {type.emissionSource}
                                </Col>
                                <Col lg={3}>
                                    {type.flow}
                                </Col>
                                <Col lg={2}>
                                    {type.tco2}
                                </Col>
                                <Col lg={2}>
                                    {type.tch4}
                                </Col>
                                <Col lg={2}>
                                    {type.tn26}
                                </Col>
                                <Col lg={2}>
                                    {type.thfc}
                                </Col>
                                <Col lg={2}>
                                    {type.tcO2e}
                                </Col>
                                <Col lg={2}>
                                    <Progress steps={12} percent={Number.parseInt(type.input)} size={20} strokeColor={conicColors} />
                                    <div></div>
                                </Col>

                            </Row>

                        </div>

                    ))}

                    <Row justify="start" className={style["custom-row-total" + isNone]}>
                        <Col lg={9}>
                            {"Categoria " + type.type + " (" + type.name + ")"}
                        </Col>
                        <Col lg={2}>
                            {type.totaltco2}
                        </Col>
                        <Col lg={2}>
                            {type.totaltch4}
                        </Col>
                        <Col lg={2}>
                            {type.totaltn2o}
                        </Col>
                        <Col lg={2}>
                            {type.totalthfc}
                        </Col>
                        <Col lg={2}>
                            {type.totaltco2e}
                        </Col>
                        <Col lg={2}>
                            <Progress percent={Number.parseInt(type.totalinput)} size={[200, 20]} strokeColor="green" />

                        </Col>
                    </Row>


                </div>
            ))}
            <Row justify="start" className={style["custom-row-total" + isNone]}>
                <Col lg={9}>
                    Total Emisiones CO₂e (t)
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontco2}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontch4}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontn2o}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissionthfc}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontco2e}
                </Col>
                <Col lg={2}>
                    {isYearSelected
                        ?
                        Number.parseInt(results!.totalEmissioninput) < 100
                            ?
                            <Progress steps={5} percent={Number.parseInt(results!.totalEmissioninput)} size={20} strokeColor='green' />
                            :
                            <div><Progress steps={5} percent={Number.parseInt(results!.totalEmissioninput)} size={20} strokeColor='green' /> {results!.totalEmissioninput}</div>

                        :
                        <div></div>
                    }
                </Col>
            </Row>

            {props.typeResult == "PORTAFOLIO" && <Row justify="start" className={style["custom-row-total" + isNone]}>
                <Col lg={9}>
                    Total Emisiones CO₂e (t) x FA
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontco2FA}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontch4FA}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontn2oFA}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissionthfcFA}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontco2eFA}
                </Col>
                
            </Row>
            }


            <Row justify="start" className={style["custom-row-data-total" + isNone]}>
                <Col lg={12}>
                    Emisiones biogénicas por combustión de biomasa CO₂ (t)
                </Col>
                <Col lg={12}>
                    {results?.totalEmissionBiomasa}
                </Col>


            </Row>
            <Row justify="start" className={style["custom-row-data-total" + isNone]}>
                <Col lg={12}>
                    Emisiones HCFC
                </Col>
                <Col lg={12}>
                    {results?.totalHcfc}
                </Col>
            </Row>
            <div className={style["title-reults"]} >
                2. HUELLA DE CARBONO POR CATEGORÍA
            </div>
            <Row justify="start" >
                <Col lg={13}>
                    <Row justify="start" className={style["custom-row" + isNone]}>
                        <Col lg={12}>
                            Categoria
                        </Col>
                        <Col lg={5}>
                            TOTAL CO₂e (t)
                        </Col>
                        <Col lg={5}>
                            Aporte %
                        </Col>
                    </Row>
                    {category.map((type: CategoryResponse) => (
                        <Row justify="start" className={style["custom-row-data" + isNone]}>
                            <Col lg={12}>
                                {"Categoria " + type.type + " (" + type.name + ")"}
                            </Col>
                            <Col lg={5}>
                                {type.totaltco2e}
                            </Col>
                            <Col lg={5}>

                                <Progress type="dashboard" percent={Number.parseInt(type.totalinput)} strokeColor={conicColors} />
                            </Col>
                        </Row>
                    ))}
                </Col>
                <Col lg={5}>
                    {isYearSelected
                        ?
                        <div className={style["chart-reultsPie"]}>
                            <Doughnut data={dataPie2} />
                        </div>
                        :
                        <div>
                        </div>
                    }
                </Col>
            </Row>

            <div className={style["title-reults"]} >
                3. MATERIALIDAD
            </div>
            <Row justify="start" className={style["custom-row" + isNone]}>
                <Col lg={4}>
                    Fuente de emisión
                </Col>
                <Col lg={4}>
                    Flujo de Fuente
                </Col>
                <Col lg={4}>
                    Categoria
                </Col>
                <Col lg={4}>
                    t CO₂e
                </Col>
                <Col lg={4}>
                    Aporte %
                </Col>
            </Row>
            {category.map((cat: CategoryResponse) => (
                <div>
                    {cat.categoryResults.map((type: CategoryResults) => (
                        <div key={type.establisment} >
                            <Row justify="start" className={style["custom-row-data" + isNone]}>
                                <Col lg={4}>
                                    {type.emissionSource}
                                </Col>
                                <Col lg={4}>
                                    {type.flow}
                                </Col>
                                <Col lg={4}>
                                    {cat.type}
                                </Col>
                                <Col lg={4}>
                                    {type.tcO2e}

                                </Col>
                                <Col lg={4}>
                                    <Progress steps={25} percent={Number.parseInt(type.input)} size={20} strokeColor={conicColors} />

                                </Col>
                            </Row>
                        </div>

                    ))}
                </div>
            ))}

        </div>

    );
    { }
};
const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getGeiYearsByOrganizationId, getCategoriesByOrganizationIdAndYear, getCategoriesByOrganizationUnifiedIdAndYear,
    getAllOrganization, getUserByTokenAll, getPortafolioGeiYearsByOrganizationId
})(ResultsUnified);